<template>
  <div
    class="error-page__container"
    :style="{ 'background-image': `url(${ imageUrl })` }"
  >
    <div class="error-page__content">
      <div class="error-page__code">
        {{ props.errorCode }}
      </div>
      <div class="error-page__description">
        <h1 class="error-page__heading">
          You seem to be lost.
        </h1>
        <h2 class="error-page__subheading">
          Let us help you find your way.
        </h2>
        <form
          id="suggestion_form"
          action="https://www.garmin.com/en-US/search/"
          method="get"
          name="searchform"
          class="error-page__form"
        >
          <label
            for="js-gheader-search-field"
            class="error-page__visually-hidden"
          >
            Search Garmin.com
          </label>
          <input
            id="js-gheader-search-field"
            type="text"
            class="error-page__search"
            data-default="Search Garmin.com"
            autocomplete="off"
            value=""
            maxlength="256"
            name="query"
          >
          <input
            type="submit"
            value="Go"
            class="error-page__search-button"
          >
        </form>
        <a
          :href="goToHomePage"
          class="error-page__btn1"
        >Go to our Home Page</a>
        <a
          class="error-page__logo"
          :href="goToHomePage"
          data-ua-event="Global Header, Logo, Logo Link"
        >
          <svg
            version="1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 107 30"
          >
            <title>Garmin</title>
            <defs>
              <path
                id="a"
                d="M0 0h107v29.028H0z"
              />
            </defs>
            <clipPath id="b">
              <use
                xlink:href="#a"
                overflow="visible"
              />
            </clipPath>
            <!-- eslint-disable max-len -->
            <path
              clip-path="url(#b)"
              d="M27.93 14.623c-.177-.358-.65-.65-1.05-.65h-.816c-.4 0-.868.296-1.04.656l-6.46 13.49c-.178.357.017.612.417.612h1.493c.59 0 .86-.268 1.018-.596.16-.328.517-1.042.585-1.187.092-.198.376-.32.776-.318l6.95.004c.4 0 .657.077.775.313.077.153.432.795.607 1.145.176.35.472.637 1.046.637h2.165c.4 0 .575-.304.43-.586-.142-.283-6.892-13.523-6.892-13.523m-4.08 9.925c-.4 0-.587-.298-.42-.66l2.546-5.45c.17-.364.443-.362.608 0l2.478 5.452c.165.364-.027.66-.427.66l-4.784-.002zm53.98-9.82V28.11c0 .37.326.622.727.622h1.765c.4 0 .728-.256.728-.656V14.7c0-.4-.26-.727-.66-.727H78.56c-.402 0-.73.246-.73.754M48.26 23.11c-.23-.328-.105-.69.28-.804 0 0 1.524-.456 2.254-1.11.73-.657 1.097-1.605 1.097-2.84 0-.807-.142-1.486-.423-2.04-.28-.55-.684-1-1.21-1.346-.523-.347-1.15-.6-1.882-.76-.732-.16-1.72-.206-1.72-.206-.4-.018-1.055-.033-1.454-.033h-7.327c-.4 0-.727.327-.727.728v13.376c0 .4.327.656.727.656h1.734c.4 0 .728-.256.728-.656 0 0 0-5.32.004-5.32.002 0 .004-.003.004-.007s3.287-.008 3.287-.008c.4 0 .917.267 1.148.594l3.413 4.805c.318.425.62.59 1.02.59h2.267c.4 0 .463-.377.325-.573-.138-.193-3.545-5.047-3.545-5.047m-1.38-2.716c-.45.103-.955.124-.955.124-.4.017-1.054.032-1.454.032H41.07c-.4 0-.727-.328-.727-.728v-2.71c0-.4.327-.728.728-.728h3.398c.4 0 1.054.014 1.454.03 0 0 .506.02.955.125.45.103.806.247 1.066.434.262.188.45.408.562.66.11.254.168.53.168.83 0 .3-.057.578-.168.83-.113.254-.3.475-.562.662-.26.19-.616.335-1.066.438m52.617-6.42c-.4 0-.724.263-.724.648l.004 8.556c0 .4-.227.492-.504.204l-8.567-8.887c-.278-.288-.685-.523-1.234-.523h-1.612c-.507 0-.728.27-.728.544v13.682c0 .273.26.533.66.533h1.615c.4 0 .68-.217.68-.585l.007-9.014c0-.4.226-.49.504-.2l8.933 9.286c.283.284.628.516 1.24.516h1.213c.4 0 .728-.327.728-.728V14.7c0-.4-.326-.727-.727-.727h-1.49zm-34.93 8.34c-.194.35-.514.35-.706 0l-4.188-7.69c-.178-.358-.543-.65-1.052-.65h-2.27c-.4 0-.73.325-.73.726v13.36c0 .4.264.672.73.672h1.41c.402 0 .69-.253.69-.638 0-.185.006-9.717.02-9.717.017 0 5.228 9.714 5.228 9.714.19.353.652.355.844.004 0 0 5.254-9.69 5.27-9.69.016 0 .01 9.41.01 9.69 0 .385.31.637.71.637h1.625c.4 0 .727-.198.727-.727V14.7c0-.4-.326-.727-.727-.727H69.98c-.556 0-.89.283-1.09.63l-4.326 7.712zM0 21.34c0 7.206 7.372 7.572 8.85 7.572 4.892 0 6.96-1.322 7.045-1.38.306-.172.68-.52.68-1.175v-4.974c0-.46-.374-.832-.833-.832H9.596c-.46 0-.76.374-.76.833v.515c0 .46.3.833.76.833h3.555c.344 0 .623.28.623.622l-.004 2.32c-.703.286-3.902 1.22-6.472.607-3.728-.892-4.018-3.968-4.018-4.89 0-.772.232-4.646 4.81-5.038 3.707-.318 6.148 1.18 6.172 1.194.436.226.887.065 1.13-.396 0-.004.46-.937.46-.937.193-.384.128-.782-.34-1.1-.03-.018-2.63-1.427-6.66-1.427C.247 13.686 0 20.556 0 21.34"
            /><path
              clip-path="url(#b)"
              fill="#007DC3"
              d="M98.68 10.284h-9.655c-.354 0-.658-.176-.835-.482-.177-.306-.177-.657 0-.963L93.017.482C93.195.175 93.5 0 93.853 0s.657.175.834.48l4.827 8.358c.178.307.178.657 0 .964-.177.306-.48.482-.835.482"
            />
            <!-- eslint-enable max-len -->
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import useLocaleStore from '../store/locale';

const props = defineProps({
  errorCode: {
    type: String,
    required: true,
  },
});

const localeStore = useLocaleStore();
const { getLocale: locale } = storeToRefs(localeStore);

const goToHomePage = computed(() => (`${window.origin}/${locale.value}/`));

const imageUrl = computed(() => {
  const images = [
    'https://res.garmin.com/error-pages/airplane-runway.jpg',
    'https://res.garmin.com/error-pages/beach-running.jpg',
    'https://res.garmin.com/error-pages/boat-ocean.jpg',
    'https://res.garmin.com/error-pages/camping-snow.jpg',
    'https://res.garmin.com/error-pages/cycling.jpg',
    'https://res.garmin.com/error-pages/geocaching.jpg',
    'https://res.garmin.com/error-pages/golfing-course.jpg',
    'https://res.garmin.com/error-pages/golfing-drive.jpg',
    'https://res.garmin.com/error-pages/hiking-rock.jpg',
    'https://res.garmin.com/error-pages/hunting-field.jpg',
    'https://res.garmin.com/error-pages/running-street.jpg',
    'https://res.garmin.com/error-pages/sailboat-water.jpg',
    'https://res.garmin.com/error-pages/swimming-beach.jpg',
  ];
  return images[Math.floor(Math.random() * images.length)];
});
</script>

<style lang="scss" scoped>
.error-page {
  &__container {
    overflow: auto;
    width: 100%;
    height: 100%;
    min-height: 400px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;

    @media screen and (min-width: 768px) {
      text-align: left;
    }
    @media screen and (min-width: 992px) {
      min-height: 600px;
    }
  }

  &__content {
    background-color: rgba(255, 255, 255, 0.85);
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.1);
    min-width: 40%;
    margin: 50px;
    border-radius: 5px;
    padding: 2rem;

    @media screen and (min-width: 768px) {
      display: flex;
    }
    @media screen and (min-width: 992px) {
      float: right;
    }
  }

  &__code {
    font-size: 72px;
    text-align: center;
    color: rgb(0, 125, 195);
    text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.75);
    line-height: 96px;
    font-weight: bold;
    margin: 0 0 2rem 0;

    @media screen and (min-width: 768px) {
      font-size: 120px;
      text-align: left;
      margin-right: 2rem;
    }
  }

  &__heading {
    font-size: 26px;
    font-weight: 5;
    margin: 0 0 8px 0;
  }

  &__subheading {
    font-size: 22px;
    font-weight: normal;
    margin: 0 0 8px 0;
  }

  &__visually-hidden {
    position: absolute;
    overflow: hidden;
    clip-path: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }

  &__form {
    margin: 0 0 18px 0;
  }

  &__search {
    max-width: 100%;
    border: 1px solid rgb(207, 207, 207);
    border-radius: 4px;
    background-color: $color-white;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.75);
    display: inline-block;
    margin-bottom: 9px;
    padding: 4px 10px 4px 5px;
    height: 28px;
    width: 210px;
    color: rgb(85, 85, 85);
    vertical-align: top;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    box-sizing: border-box;
  }

  &__search-button {
    background: url('https://res.garmin.com/error-pages/search-blue.png') no-repeat;
    border: none;
    text-indent: -1000px;
    width: 15px;
    height: 15px;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    padding: 1px 7px 2px 7px;
    margin-left: 4px;
  }

  &__btn1 {
    display: inline-block;
    margin-bottom: 1rem;
    padding: 0 8px 0 8px;
    color: $color-white;
    text-decoration: none;
    background-color: rgb(0, 108, 171);
    background-image:
      linear-gradient(
        to top,
        rgb(0, 124, 195) 0,
        rgb(0, 151, 227) 100%
      );
    border-color: rgb(0, 115, 181);
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.25);
    white-space: nowrap;
    font-weight: bold;
    font-size: 14px;
    line-height: 28px;
  }

  &__logo {
    display: block;
    text-decoration: none;
    box-sizing: border-box;

    svg {
      max-width: 170px;
    }
  }

  h1,
  h2 {
    letter-spacing: -0.035em;
    margin: 0 0 8px;
    line-height: 1.4;
    color: rgb(34, 34, 34);
  }

  p,
  label,
  li,
  div {
    line-height: 20px;
  }
}
</style>
